(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.factory('ExternalLocationService', ['$http', ExternalLocationServiceFn]);
    
    function ExternalLocationServiceFn($http, $rootScope, $uibModalStack, $uibModal) {

        var baseUrl = '/api/externallocations/';
        var service = {
            getAllExternalLocations,
            getExternalLocation,
            createExternalLocation,
            updateExternalLocation,
            deleteExternalLocation       
        };

        return service;

        function get(url) {
            return $http.get(url)
                        .then(function (response) {
                            return response.data;
                        });
        }

        function getAllExternalLocations(agendaId) {
            return get(`${baseUrl}agendas/${agendaId}`);
        }

        function getExternalLocation(agendaId, locationId) {
            return get(`${baseUrl}${locationId}/agendas/${agendaId}`);
        }

        function createExternalLocation(externalLocation) {
                    return $http.post(`${baseUrl}`, externalLocation)
                                .then(function (response) {
                        return response.data;
                    });
        }

        function updateExternalLocation(externalLocation) {
            return $http.put(`${baseUrl}`, externalLocation)
                        .then(function (response) {
                return response.data;
            });
        }

         function deleteExternalLocation(agendaId, locationId) {
            return $http.delete(`${baseUrl}${locationId}/agendas/${agendaId}`)
                        .then(function (response) {                
                return response.data;
            });
         }
    } 
})();